import { useMemo } from 'react';

import Balota from '../../../common/components/Balota/Balota';
import { BALOTA_SIZES, BALOTA_STATES } from '../../../common/components/Balota/constants';
import { buildDrumBalls } from '../utils/drum';

import '../styles/machine.css';

// Subcomponent surface of the hero (TSS vite/01 §"File-per-concern rule" —
// a subcomponent file inside layouts/ rather than a third nesting level).

function DrumBall({ ball }) {
    return (
        <span
            className="draw-machine__ball"
            style={{
                '--ball-size': `${ball.size}px`,
                '--ball-left': `${ball.left}%`,
                '--ball-top': `${ball.top}%`,
                '--drift-x': `${ball.driftX}px`,
                '--drift-y': `${ball.driftY}px`,
                '--duration': `${ball.duration}s`,
                '--delay': `${ball.delay}s`,
            }}
        >
            {ball.digit}
        </span>
    );
}

export default function DrawMachine({ digits, isSpinning, number }) {
    const balls = useMemo(() => buildDrumBalls(), []);

    return (
        <div className={`draw-machine ${isSpinning ? 'draw-machine--spinning' : ''}`}>
            <div className="draw-machine__drum" aria-hidden="true">
                <span className="draw-machine__core" />
                {balls.map(ball => <DrumBall key={ball.id} ball={ball} />)}
                <span className="draw-machine__glass" />
            </div>

            <div className="draw-machine__chute">
                <span className="draw-machine__label">
                    {isSpinning ? 'Sorteando…' : 'Último combinado'}
                </span>
                <div
                    className="draw-machine__balls"
                    role="status"
                    aria-live="polite"
                    aria-label={isSpinning ? 'Sorteo en curso' : `Combinado ganador ${number}`}
                >
                    {digits.map((digit, index) => (
                        <Balota
                            key={index}
                            digit={digit.value}
                            size={BALOTA_SIZES.LG}
                            state={digit.isLocked ? BALOTA_STATES.LOCKED : BALOTA_STATES.SPINNING}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}
